// TODO: Move to wrangler.toml
export const STRIPE_PUBLIC_API_KEY =
  "pk_test_51O9lXSIqXHRmMKBSy7OaiBx69BXBRKcH0nBBkerJnIvrH5TV369uB5hP5RWUUuhP6gkJvvSYul4WrQ9p3xXKKeJ100a53sQ0c2";

export const STRIPE_CREATE_PAYMENT_INTENT_PATH =
  "/resources/stripe/create-confirm-intent";

export const STRIPE_CREATE_CHECKOUT_PATH = "/resources/stripe/create-checkout";
